import React, { useEffect, useState } from "react";
import "./RCPdfList.css";

const RCPdfList = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  // ================== DOWNLOAD FUNCTION ==================
  const downloadPDF = (pdfData, rcno) => {
    try {
      if (!pdfData) {
        alert("PDF not found");
        return;
      }

      // Cleanup + normalize
      let base64 = pdfData.trim();

      // remove prefix if exists
      if (base64.startsWith("data:")) {
        base64 = base64.split(",")[1];
      }

      // remove whitespace / newlines
      base64 = base64.replace(/\s/g, "");

      // url safe fix
      base64 = base64.replace(/-/g, "+").replace(/_/g, "/");

      // padding fix
      while (base64.length % 4 !== 0) {
        base64 += "=";
      }

      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });

      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `RC_${rcno}.pdf`;
      a.click();

      URL.revokeObjectURL(url);

    } catch (err) {
      console.log(err);
      alert("PDF Download Failed ❌");
    }
  };

  // ================== FETCH LIST ==================
  useEffect(() => {
    const fetchList = async () => {
      try {
        const res = await fetch(
          `https://rcfinder.online/api/get_rc_list.php?user_id=${user.id}`
        );

        const data = await res.json();
        console.log(data);

        if (data.list) setList(data.list);

      } catch (err) {
        console.log(err);
        alert("Server Error");
      }

      setLoading(false);
    };

    fetchList();
  }, []);

  return (
    <div className="rc-list-wrapper">

      {loading && (
        <div className="rc-list-loading">
          <div className="loader"></div>
          <p>Fetching your RC history...</p>
        </div>
      )}

      <h2 className="rc-list-title">RC PDF History</h2>

      <div className="rc-list-box">

        {list.length === 0 ? (
          <p className="no-data">No RC history found 😐</p>
        ) : (
          <table className="rc-table">
            <thead>
              <tr>
                <th>#</th>
                <th>RC Number</th>
                <th>Name</th>
                <th>Date</th>
                <th>Download</th>
              </tr>
            </thead>

            <tbody>
              {list.map((r, i) => (
                <tr key={r.id}>
                  <td>{i + 1}</td>
                  <td>{r.rcno}</td>
                  <td>{r.name}</td>
                  <td>{r.created_at}</td>
                  <td>
                    <button
                      className="download-btn"
                      onClick={() => downloadPDF(r.pdf_data, r.rcno)}
                    >
                      Download
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        )}

      </div>
    </div>
  );
};

export default RCPdfList;
